import { updateRef } from './updateRef';
export const mergeRefs = (ref1, ref2) => (node) => {
    updateRef(ref1, node);
    updateRef(ref2, node);
};
